import type { Components, Theme } from '@mui/material/styles';

import { SHAPE, token } from './scales';

/** The kit uploads: the drop zone. */
export const UPLOADS: Components<Theme> = {
  KitDropzone: {
    styleOverrides: {
      root: ({ theme }) => ({
        width: '100%',
        borderRadius: SHAPE.medium,
        border: `1px dashed ${theme.vars.palette.outline}`,
        '&:hover': { borderColor: theme.vars.palette.grey[500] },
        '&.Mui-disabled': { opacity: 0.6 },
        '& svg': { color: theme.vars.palette.text.secondary },
      }),
    },
    variants: [
      {
        props: { dragging: true },
        style: ({ theme }) => ({ borderColor: token('brand-500'), backgroundColor: theme.vars.palette.tint.brand.fill }),
      },
    ],
  },
};
